
import React from 'react';
import Layout from './components/layout';
import AppRoutes from './components/router';
import { Translator, Config, LanguageList } from 'react-translator-component';
import AlertModal from '@components/elements/Alert';

import en from '@config/locale/en';
import ar from '@config/locale/ar';
import de from '@config/locale/de';
import zhcn from '@config/locale/zhcn';
import zhtw from '@config/locale/zhtw';
import { arIcon, deIcon, enIcon, zhcnIcon, zhtwIcon } from '@config/flag';
import { useLanguage } from '@hooks/useLanguage';

const App: React.FC<{}> = () => {
  const { language } = useLanguage();

  /* Default Language */
  Config.default = language;

  /* Language List */
  Config.list = {
    de: {
      text: 'Deutsch',
      icon: deIcon,
      file: de,
    },
    en: {
      text: 'English',
      icon: enIcon,
      file: en,
    },
    ar: {
      text: 'العربية',
      icon: arIcon,
      file: ar,
    },
    zhcn: {
      text: '简体中文',
      icon: zhcnIcon,
      file: zhcn,
    },
    zhtw: {
      text: '繁體中文',
      icon: zhtwIcon,
      file: zhtw,
    },
  };

  return (
    <Translator>
      <LanguageList Language={language}></LanguageList>
      <Layout>
        <AlertModal />
        <AppRoutes />
      </Layout>
    </Translator>
  );
};

export default App;
